export default {
  name: "MyNavBar",
  props: {
    title: {
      type: String,
      default: ''
    },
    isReturn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    GoBack() {
      this.$router.go(-1);
    }
  }
};